import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KProperty0Class;
function KProperty0() {
  if (KProperty0Class === VOID) {
    class $ {}
    initMetadataForInterface($, 'KProperty0');
    KProperty0Class = $;
  }
  return KProperty0Class;
}
var KProperty1Class;
function KProperty1() {
  if (KProperty1Class === VOID) {
    class $ {}
    initMetadataForInterface($, 'KProperty1');
    KProperty1Class = $;
  }
  return KProperty1Class;
}
var KMutableProperty0Class;
function KMutableProperty0() {
  if (KMutableProperty0Class === VOID) {
    class $ {}
    initMetadataForInterface($, 'KMutableProperty0', VOID, VOID, [KProperty0()]);
    KMutableProperty0Class = $;
  }
  return KMutableProperty0Class;
}
var KMutableProperty1Class;
function KMutableProperty1() {
  if (KMutableProperty1Class === VOID) {
    class $ {}
    initMetadataForInterface($, 'KMutableProperty1', VOID, VOID, [KProperty1()]);
    KMutableProperty1Class = $;
  }
  return KMutableProperty1Class;
}
//region block: exports
export {
  KMutableProperty0 as KMutableProperty025txtn5b59pq1,
  KMutableProperty1 as KMutableProperty11e8g1gb0ecb9j,
  KProperty0 as KProperty02ce7r476m8633,
  KProperty1 as KProperty1ca4yb4wlo496,
};
//endregion

//# sourceMappingURL=KPropertyJs.mjs.map
